// Two prompt sets for the Sunday digest's "ONE QUESTION" reflection.
// `celebratory` is the default; `softer` fires when useHonestDay() is
// true on the day the user reads the digest (Phase B §P10.6 honest-day
// suppression).
//
// Selection is deterministic per-user/per-week from a hash of the
// digest's generatedAt so a user who reads the digest twice on Sunday
// sees the same question both times. The hash lives in WeeklyDigest.

/** @public Reserved for the upcoming celebratory digest variant. */
export const REFLECTION_PROMPTS_CELEBRATORY = [
  "When this week did you feel most like the person you want to become?",
  "What did your body teach you that your mind hadn't noticed?",
  "Which moment this week proved a piece of the old story wrong?",
  "What does tomorrow-you need to hear first thing in the morning?",
  "Of the things you didn't do this week, which absence was the win?",
  "What did you decide *not* to negotiate with this week?",
  "Whose version of you showed up most often — and is that the one you want?",
  "Which boundary held this week — and what made it hold?",
];

export const REFLECTION_PROMPTS_SOFTER = [
  "What helped today even though you went over?",
  "Where did kindness slip in, even briefly, this week?",
  "What's one thing past-you would forgive present-you for?",
  "When did you take care of yourself this week, even a little?",
  "What is true about you today that isn't measured by a number?",
  "What's the smallest thing that worked this week, even once?",
  "If a friend had your week, what would you say to them?",
  "What do you want to be allowed to feel tomorrow?",
];

/**
 * Deterministic, stable index hash for picking a prompt from a set.
 * Uses a 32-bit FNV-1a fold over the input string. We index into the
 * SOFTER set in particular so a user who hits an honest day on
 * Sunday morning and reopens the app at 4pm sees the same prompt.
 *
 * Returns a non-negative integer; callers should `% prompts.length`.
 */
export function hashDate(input: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < input.length; i += 1) {
    h ^= input.charCodeAt(i);
    // 32-bit FNV prime multiply, kept in 32 bits with imul.
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}
